"use strict";

exports.__esModule = true;


// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

exports.default = capitalizeString;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/polished/lib/internalHelpers/_capitalizeString.js
// module id = 730
// module chunks = 168707334958949